import { render, staticRenderFns } from "./DatastoreCreator.vue?vue&type=template&id=dfed9288"
import script from "./DatastoreCreator.vue?vue&type=script&lang=js"
export * from "./DatastoreCreator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports